export default __webpack_public_path__ + "static/media/ART19.c17ea0a8.jpg";